export default "__VITE_ASSET__CXsHOE4F__"